<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <CategoryForm :formProps="formProps">
                </CategoryForm>
            </template>
            <template #search="searchProps">
                <CategorySearch :searchProps="searchProps">
                </CategorySearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import CategoryForm from './CategoryForm.vue'
import CategorySearch from './CategorySearch.vue'
import { ref } from "vue";
import { rowButtonAction } from '@pages/Helper/crud_utils.js'

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])

//----------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
